export var AuditTrailSubject;
(function (AuditTrailSubject) {
    AuditTrailSubject["EmptyState"] = "audit-trail-empty-state";
})(AuditTrailSubject || (AuditTrailSubject = {}));
//# sourceMappingURL=audit-trail.enum.js.map